export default __webpack_public_path__ + "fdf55154cee5882f1806128cf91c6f77.png";